function getPageQuery() {
  const params = new URLSearchParams(window.location.search || "");
  const hash = window.location.hash || "";
  const hashQueryIndex = hash.indexOf("?");
  if (hashQueryIndex > -1) {
    const hashParams = new URLSearchParams(hash.slice(hashQueryIndex + 1));
    hashParams.forEach((value, key) => {
      if (!params.has(key)) {
        params.set(key, value);
      }
    });
  }
  return params;
}

export function createDeviceInfo() {
  const query = getPageQuery();

  let platform = query.get("platform");
  let deviceFrom = query.get("device");

  if (platform) {
    localStorage.setItem("URL_PARAM_platform", platform);
  } else {
    platform = localStorage.getItem("URL_PARAM_platform") || "";
  }

  if (deviceFrom) {
    localStorage.setItem("URL_PARAM_device", deviceFrom);
  } else {
    deviceFrom = localStorage.getItem("URL_PARAM_device") || "";
  }

  const isAndroid =
    navigator.userAgent.indexOf("Android") > -1 ||
    navigator.userAgent.indexOf("Adr") > -1;

  let xDevice = "";
  if (isAndroid) {
    xDevice = deviceFrom === "native" ? "android" : "androidH5";
  } else {
    xDevice =
      deviceFrom === "native" || deviceFrom === "manifest" ? "ios" : "iosH5";
  }

  let xAppPlatform = "";
  if (xDevice === "androidH5" && window.location.search.indexOf("mode=pwa") > -1) {
    xAppPlatform = "androidpwa";
  }
  if (xDevice === "iosH5" && navigator.standalone === true) {
    xAppPlatform = "iospwa";
  }
  if (deviceFrom === "manifest") {
    xAppPlatform = "iosprofile";
  }

  return {
    platform: platform || "",
    device: isAndroid ? "android" : "ios",
    deviceFrom: deviceFrom || "",
    xDevice: xDevice,
    xAppPlatform: xAppPlatform,
    isBroswer: deviceFrom !== "native" && deviceFrom !== "manifest",
    isPWA: xAppPlatform === "androidpwa" || xAppPlatform === "iospwa",
    isNativeAPP: xDevice === "android" || (xDevice === "ios" && deviceFrom !== "manifest"),
    isManifest: deviceFrom === "manifest",
  };
}

export const deviceInfo = createDeviceInfo();
window.deviceInfo = deviceInfo;
